export default function hideFloatingElement(el?: HTMLElement | null): boolean {
    if (!el) return false;
    if (el.style.opacity === '0') return false;

    el.style.opacity = '0';
    el.style.top = '';
    el.style.left = '';

    return true;
}

// #region Tests

if (import.meta.vitest) {
    const { describe, it } = import.meta.vitest;
    describe('hideFloatingElement', async () => {
        it.todo('🤷🏼');
    });
}

// #endregion
